import React from 'react';
import Rightel from '../style/images/receptions/Rightel.png';
import cspf from '../style/images/receptions/cspf.png';
import etma from '../style/images/receptions/etma.png';
import glorit from '../style/images/receptions/glorit.png';
import iranAp from '../style/images/receptions/Iran_AP.png';
import mehr from '../style/images/receptions/bank-mehr.png';
import tamin from '../style/images/receptions/Tamin.png';
import ellipse from '../style/images/Group-5.png';

const Guide = ({logos}) => {
    return(
        <div>
                    <span>
                        <img src={ellipse}/>
                    </span>
            {
                logos ? (<span className='preFooter-title'>سازمان های همکار</span>): (
                    <span className='preFooter-title-guide'>راهنما </span>
                )
            }
            
            {
                logos ? (  <div className='preFooter-reception-logos'>
                    <img src={cspf} alt='cspf' height={50}/>
                    <img src={Rightel} alt='Rightel' height={50}/>
                    <img src={iranAp} alt='iranAp' height={50}/>
                    <img src={glorit} alt='glorit' height={50}/>
                    <img src={mehr} alt='mehr' height={50}/>
                    <img src={etma} alt='etma' height={50}/>
                    <img src={tamin} alt='tamin' height={50}/>
                </div>) : (
                    <ul>
                        <li>
                            درگاه پرداخت اعتباری کیپا با استفاده از پروتکل امن SSL به مشتریان خود ارائه خدمت نموده و با آدرس https://pay.kipaa.ir شروع می شود. خواهمشند است به منظور جلوگیری از سو استفاده های احتمالی پیش از ورود هرگونه اطلاعات، آدرس موجود در بخش مرورگر وب خود را با آدرس فوق مقایسه نمایید و در صورت مشاهده هرگونه مغایرت احتمالی، موضوع را با شماره تماس پشتیبانی 02191074757 در میان بگذارید.
                        </li>
                        <li>
                            از صحت نام و اطلاعات پذیرنده و مبلغ نمایش داده شده، اطمینان حاصل فرمائید.
                        </li>
                        <li>
                            مبلغ قابل پرداخت، مبلغ کل کالا و خدمات خریداری شده بوده و میزان مبلغ نقدی و اعتباری قابل پرداخت بر اساس اعتبار مشتری در بخش درگاه تعیین خواهد شد.
                        </li>
                        <li>
                            درصورتی که پذیرنده هستید، از طریق پرتال گزارشات می توانید به کلیه سوابق فروش و گزارشات مالی و حسابداری دسترسی داشته باشید.
                        </li>
                        <li>
                            در صورتی که مشتری در یکی از سازمان های همکار عضویت داشته باشد، شما می توانید از طریق درگاه اعتباری کیپا، به صورت اعتباری و اقساطی اقدام به فروش کالا و خدمات نمائید.
                        </li>
                        <li>
                            برای کسب اطلاعات بیشتر، اعلام مشکلات ثبت تراکنش و اتصال به سوییچ اعتباری کیپا از طریق شماره 0219074757 واحد پذیرندگان اقدام فرمائید.
                        </li>
                    </ul>
                )
            }
        
        </div>
    )
};

export default Guide;